var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "checkout p-md-4" },
    [
      _c(_vm.checkoutStep, {
        tag: "component",
        on: { handleChange: _vm.changeStep },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }